import React from "react";

import { css } from "@mui/material";
import { styled } from "@mui/material/styles";
import logoUrl from "./assets/intelligems-logo-icon.svg";

const style = css`
  #ig-loading {
    z-index: 9999999999;
    animation: fadeLoop 1.5s ease-in-out infinite;
  }

  @keyframes fadeLoop {
    0%,
    100% {
      opacity: 0.1;
    }
    50% {
      opacity: 1;
    }
  }
`;

const Root = styled("div")(style);

interface IgLoadingProps {
  className?: string;
}

export const IgLoading = ({ className }: IgLoadingProps) => {
  return (
    <Root className={className}>
      <img src={logoUrl} width={40} height={40} id="ig-loading" alt="" />
    </Root>
  );
};
